import dayjs from "dayjs";
import { api } from ".";

export const updateCompanyById = async ({ updates }: any) => {
  try {
    const res = await api.put(`/company`, {
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getEmployeeById = async (id: string) => {
  try {
    const res = await api.get(`/company?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const uploadCompanyPhoto = async (formData: any, type: any) => {
  try {
    const res = await api.post(`/photo/upload?type=${type}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    console.error("Error uploading photo:", error);
    return error;
  }
};

export const getCompanyPhoto = async (photoId: any, type: any) => {
  try {
    const res = await api.get(`/photo?photoId=${photoId}&type=${type}`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    return error;
  }
};
